module.exports = __webpack_public_path__ + "static/landmarks-a6cd169f4bed7acd380b35ceab7ef148.png";